<template>
  <div class="main">
    <div class="carousel">
      <div class="mt-8 typeSquare pl-16">
        <div
          class="mb-4 text-center text-uppercase black--text sigflo-h3 venueTitle"
        >
          {{ data.contentImageTitle }}
        </div>
        <div class="venueContainer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="402"
            height="402"
            viewBox="0 0 402 402"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M402 46.5295C402 20.832 381.168 0 355.47 0H100.5C79.7893 0 63 16.7893 63 37.5V43.5C63 60.897 48.897 75 31.5 75C14.103 75 0 89.103 0 106.5V355.47C0 381.168 20.832 402 46.5295 402H289.5C310.763 402 328 384.763 328 363.5V362C328 341.565 344.565 325 365 325C385.435 325 402 308.435 402 288V46.5295Z"
              fill="#D9D9D9"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M402 46.5295C402 20.832 381.168 0 355.47 0H100.5C79.7893 0 63 16.7893 63 37.5V43.5C63 60.897 48.897 75 31.5 75C14.103 75 0 89.103 0 106.5V355.47C0 381.168 20.832 402 46.5295 402H289.5C310.763 402 328 384.763 328 363.5V362C328 341.565 344.565 325 365 325C385.435 325 402 308.435 402 288V46.5295Z"
              :fill="'url(#' + patternId + ')'"
            />
            <defs>
              <pattern
                :id="patternId"
                patternUnits="userSpaceOnUse"
                width="402"
                height="402"
              >
                <image
                  :id="imageId"
                  class="venueImage"
                  width="402"
                  height="402"
                  :xlink:href="data.contentImage"
                  preserveAspectRatio="xMidYMid slice"
                />
              </pattern>
            </defs>
          </svg>

          <div class="buttonText sigflo-buttonText white--text">
            Start Building
          </div>
          <v-btn small color="black" fab dark rounded class="button"
            ><v-icon>mdi-arrow-top-right</v-icon></v-btn
          >
        </div>
      </div>
    </div>
    <div class="text1">
      <div class="text-right sigflo-l" v-html="data.contentTitle"></div>
      <div class="text-right sigflo-bodyLarge mt-4" v-html="data.content"></div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      data: Object
    },
    data() {
      return {
        patternId: 'systemDetailsPattern_0',
        imageId: 'systemDetailsImage_0'
      };
    },
    computed: {
      ...mapState(['configurator'])
    }
  };
</script>

<style scoped>
  .main {
    position: relative;

    width: 1442px;
    height: 668px;
    flex-shrink: 0;
  }
  .carousel {
    position: absolute;
    top: 0px;
    left: 60px;
    width: 530px;
    height: 592px;
    flex-shrink: 0;
  }
  .carouselButton {
    position: absolute;
    bottom: 60px;
    right: 20px;
  }
  .text1 {
    position: absolute;
    top: 85px;
    right: 130px;

    width: 535px;
    height: 190px;
    flex-shrink: 0;
  }
  .text2 {
    position: absolute;
    top: 300px;
    right: 130px;

    width: 635px;
  }
  .text3 {
    position: absolute;
    top: 400px;
    right: 130px;

    width: 620px;
  }
  .text3 .sub {
    font-family: Inter V;
    font-size: 22px;
    font-weight: 700;
    line-height: 31px;
    letter-spacing: 0.4583333432674408px;
    text-align: right;
  }
</style>
